import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const BookProduct = () => {
    const { dataString } = useParams();

    useEffect(() => {
        if (dataString) {
            const parts = dataString.split("BBB");

            if (parts.length >= 2) {
                const mobileNo = parts[0];
                const designNo = parts[1];

                // Construct the WhatsApp URL
                // Using encodeURIComponent to ensure the text is properly formatted for URL
                const text = `I want to Book ${designNo}`;
                const whatsappUrl = `https://wa.me/${mobileNo}?text=${encodeURIComponent(
                    text
                )}`;

                // Redirect
                window.location.href = whatsappUrl;
            } else {
                console.error("Invalid format: expected MobileNoBBBDesignNo");
                // Optional: Redirect to home or show error
                // window.location.href = "/";
            }
        }
    }, [dataString]);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                fontSize: "1.5rem",
            }}
        >
            Redirecting to WhatsApp...
        </div>
    );
};

export default BookProduct;
